import { motion } from "framer-motion";

const orbitTransition = {
    duration: 1.8,
    repeat: Infinity,
    ease: "linear",
};

function Loader() {
    return (
        <motion.div
            className="zj-preloader"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, scale: 1.02 }}
            transition={{ duration: 0.28, ease: "easeOut" }}
            role="status"
            aria-live="polite"
            aria-label="Zozo Jobs is loading"
        >
            <motion.div
                className="zj-preloader__panel"
                initial={{ y: 18, opacity: 0, scale: 0.96 }}
                animate={{ y: 0, opacity: 1, scale: 1 }}
                exit={{ y: -12, opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
            >
                <div className="zj-preloader__mark">
                    <div className="zj-preloader__halo" />
                    <motion.div className="zj-preloader__ring zj-preloader__ring--outer" animate={{ rotate: 360 }} transition={orbitTransition} />
                    <motion.div className="zj-preloader__ring zj-preloader__ring--inner" animate={{ rotate: -360 }} transition={{ ...orbitTransition, duration: 1.25 }} />
                    <motion.div
                        className="zj-preloader__brand"
                        animate={{ scale: [1, 1.045, 1] }}
                        transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                    >
                        <img src="/logo192.png" alt="Zozo Jobs" />
                    </motion.div>
                </div>
                <div className="zj-preloader__progress">
                    <motion.span
                        initial={{ x: "-110%" }}
                        animate={{ x: ["-110%", "110%"] }}
                        transition={{ duration: 1.15, repeat: Infinity, ease: "easeInOut" }}
                    />
                </div>
                <span className="zj-preloader__copy">Loading Zozo Jobs</span>
            </motion.div>
        </motion.div>

    )
}

export default Loader;
